import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=c4c2195c"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports